import React from 'react'

const HelpCenter = () => {
  return (
    <div>HelpCenter will help student how to get dreem job</div>
  )
}

export default HelpCenter